const faqData = [
  {
    id: 1,
    question: "What is TLE MEC?",
    answer:
      "TLE MEC is the Competitive Programming and Data Structures & Algorithms club of Govt. Model Engineering College, Thrikkakara, Kochi.",
  },
  {
    id: 2,
    question: "How did we get the name TLE?",
    answer:
      "TLE - Time Limit Exceeded - is a very common term used in Competitive Programming, and refers to the condition of your code not being efficient enough, in terms of execution time. It highlights the importance of not just being correct, but being so in an efficient manner.",
  },
  {
    id: 3,
    question: "What is Competitive Programming?",
    answer:
      "Competitive programming is a mind sport usually held over the Internet or a local network, involving participants trying to program according to provided specifications.",
  },
  {
    id: 4,
    question: "What is DSA?",
    answer:
      "A data structure is a named location that can be used to store and organize data. And, an algorithm is a collection of steps to solve a particular problem. Learning data structures and algorithms allow us to write efficient and optimized computer programs.",
  },
  {
    id: 5,
    question: "Why do I need these?",
    answer:
      "A deep study into data structures and algorithms ensures well-optimized efficient code and great problem-solving skills that many tech companies seek. But not only is this beneficial for landing jobs, it also hones your skill to tackle real-world problems.",
  },
  {
    id: 6,
    question: "Where do I get started!",
    answer:
      "Try online courses by Coursera, Udemy or attend free videos from youtube! Some channel suggestions from our side are freeCodeCamp.org, thenewboston and Edureka! You can also try to master data structures using sites like geeksforgeeks & tutorialspoint. Just choose a language, learn the basics and start coding!",
  },
  {
    id: 7,
    question: "How can TLE help you?",
    answer:
      "It can be hard to find your way through the cluttered mess of the internet as you navigate resources and so we're here to point you in the right direction. We will be sharing timely resources and tips, along with holding contests from time to time so your skills don't ever get rusty!",
  },
];

export default faqData;
